import React from "react";

import "./Spinner.scss";

const Spinner = () => (
  <div className="spinner-box">
    <div className="spinner" />
  </div>
);

export default Spinner;
